import { useContext } from "react";
import { OrganizationDetailsContext } from "../components/organization-details-context";

export const useOrganizationDetails = () => {
  return useContext(OrganizationDetailsContext);
};
